"use client";

import { collection, onSnapshot, query, where } from "@firebase/firestore";
import { db } from "../FirebaseConfig.ts";
import { useEffect, useState } from "react";

const useSnapshotWithoutInvestor = (searchTerm = "") => {
  const [data, setData] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);

  // Implementar debounce de 500ms
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm]);

  useEffect(() => {
    setIsFetching(true);

    // Crear la query base - créditos sin inversionista
    let q = collection(db, "requests");

    // Si hay un término de búsqueda, intentar optimizar la consulta
    if (debouncedSearchTerm.trim()) {
      const searchLower = debouncedSearchTerm.trim().toLowerCase();

      // Si parece un número (cédula o posible ID), buscar por identity
      if (/^\d+$/.test(searchLower)) {
        q = query(
          collection(db, "requests"),
          where("identity", ">=", searchLower),
          where("identity", "<=", searchLower + "\uf8ff")
        );
      }
      // Si parece un UUID (contiene guiones), buscar por uuid
      else if (searchLower.includes("-")) {
        q = query(
          collection(db, "requests"),
          where("uuid", ">=", searchLower),
          where("uuid", "<=", searchLower + "\uf8ff")
        );
      }
      // Para nombres, traer todo y filtrar en cliente (limitación de Firebase)
      else {
        q = collection(db, "requests");
      }
    }

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        let noInvestorDocs = snapshot.docs
          .map((doc) => ({ id: doc.id, ...doc.data() }))
          .filter(
            (doc) =>
              (!("investorId" in doc) ||
                doc.investorId === null ||
                doc.investorId === "") &&
              String(doc.status || "").toLowerCase() === "aprobado"
          );

        // Si hay término de búsqueda, filtrar adicionalmente en cliente
        if (debouncedSearchTerm.trim()) {
          const searchLower = debouncedSearchTerm.trim().toLowerCase();

          noInvestorDocs = noInvestorDocs.filter((credit) => {
            const fullName = `${String(credit.name || "")} ${String(
              credit.lastName || ""
            )}`.toLowerCase();

            const identity = String(credit.identity || "").toLowerCase();
            const uuid = String(credit.uuid || "").toLowerCase();

            return (
              fullName.includes(searchLower) ||
              identity.includes(searchLower) ||
              uuid.includes(searchLower)
            );
          });
        }

        setData(noInvestorDocs);
        setIsFetching(false);
      },
      (error) => {
        console.error("Error fetching credits without investor:", error);
        setData([]);
        setIsFetching(false);
      }
    );

    return () => unsubscribe();
  }, [debouncedSearchTerm]);

  return { data, isFetching, isSearching: searchTerm !== debouncedSearchTerm };
};

export default useSnapshotWithoutInvestor;
